import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, inject, PLATFORM_ID } from '@angular/core';

interface IGalleryImage {
  src: string;
  orientation: 'landscape' | 'portrait';
  captionKey: string;
}

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss',
  standalone: false,
})
export class GalleryComponent {
  private readonly platformId = inject(PLATFORM_ID);
  // Use the DOCUMENT token rather than the global `document` for SSR safety
  private readonly document = inject(DOCUMENT);

  isViewerOpen: boolean = false;
  isCaptionVisible: boolean = true;
  selectedIndex: number = 0;

  // TODO: replace with actual gallery photography once available
  readonly images: IGalleryImage[] = [
    { src: 'assets/images/gallery/1.jpg', orientation: 'portrait', captionKey: 'gallery.item_1_caption' },
    { src: 'assets/images/gallery/2.jpg', orientation: 'landscape', captionKey: 'gallery.item_2_caption' },
    { src: 'assets/images/gallery/3.jpg', orientation: 'portrait', captionKey: 'gallery.item_3_caption' },
    { src: 'assets/images/gallery/4.jpg', orientation: 'landscape', captionKey: 'gallery.item_4_caption' },
    { src: 'assets/images/gallery/5.jpg', orientation: 'portrait', captionKey: 'gallery.item_5_caption' },
    { src: 'assets/images/gallery/6.jpg', orientation: 'landscape', captionKey: 'gallery.item_6_caption' },
    { src: 'assets/images/gallery/7.jpg', orientation: 'portrait', captionKey: 'gallery.item_7_caption' },
    { src: 'assets/images/gallery/8.jpg', orientation: 'landscape', captionKey: 'gallery.item_8_caption' },
    { src: 'assets/images/gallery/9.jpg', orientation: 'portrait', captionKey: 'gallery.item_9_caption' },
    { src: 'assets/images/gallery/10.jpg', orientation: 'landscape', captionKey: 'gallery.item_10_caption' },
    { src: 'assets/images/gallery/11.jpg', orientation: 'portrait', captionKey: 'gallery.item_11_caption' },
    { src: 'assets/images/gallery/12.jpg', orientation: 'landscape', captionKey: 'gallery.item_12_caption' },
    { src: 'assets/images/gallery/13.jpg', orientation: 'portrait', captionKey: 'gallery.item_13_caption' },
    { src: 'assets/images/gallery/14.jpg', orientation: 'landscape', captionKey: 'gallery.item_14_caption' },
    { src: 'assets/images/gallery/15.jpg', orientation: 'portrait', captionKey: 'gallery.item_15_caption' },
    { src: 'assets/images/gallery/16.jpg', orientation: 'landscape', captionKey: 'gallery.item_16_caption' },
    { src: 'assets/images/gallery/17.jpg', orientation: 'portrait', captionKey: 'gallery.item_17_caption' },
    { src: 'assets/images/gallery/18.jpg', orientation: 'landscape', captionKey: 'gallery.item_18_caption' },
  ];

  get selectedImage(): IGalleryImage {
    return this.images[this.selectedIndex];
  }

  openViewer(index: number): void {
    this.selectedIndex = index;
    this.isCaptionVisible = true;
    this.isViewerOpen = true;
    if (isPlatformBrowser(this.platformId)) this.document.body.classList.add('modal-open');
  }

  closeViewer(): void {
    this.isViewerOpen = false;
    if (isPlatformBrowser(this.platformId)) this.document.body.classList.remove('modal-open');
  }

  selectImage(index: number): void {
    this.selectedIndex = index;
  }

  showPrev(): void {
    this.selectedIndex = (this.selectedIndex - 1 + this.images.length) % this.images.length;
  }

  showNext(): void {
    this.selectedIndex = (this.selectedIndex + 1) % this.images.length;
  }

  toggleCaption(): void {
    this.isCaptionVisible = !this.isCaptionVisible;
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isViewerOpen) this.closeViewer();
  }

  @HostListener('document:keydown.arrowLeft')
  onArrowLeft(): void {
    if (this.isViewerOpen) this.showPrev();
  }

  @HostListener('document:keydown.arrowRight')
  onArrowRight(): void {
    if (this.isViewerOpen) this.showNext();
  }
}
